import { useState } from "react";

const GUNLUK_DATA = [
  { gun: "13 May", sayi: 18 }, { gun: "14 May", sayi: 24 }, { gun: "15 May", sayi: 12 },
  { gun: "16 May", sayi: 31 }, { gun: "17 May", sayi: 20 }, { gun: "18 May", sayi: 28 },
  { gun: "19 May", sayi: 16 },
];

const TUR_DATA = [
  { tur: "Referans İsteme", sayi: 102, yuzde: 42, renk: "bg-violet-500" },
  { tur: "Ödeme Hatırlatma", sayi: 87, yuzde: 35, renk: "bg-amber-500" },
  { tur: "Taahhüt Bilgilendirme", sayi: 24, yuzde: 10, renk: "bg-orange-500" },
  { tur: "Yeni Kayıt", sayi: 14, yuzde: 6, renk: "bg-emerald-500" },
  { tur: "Gecikme Takip", sayi: 12, yuzde: 5, renk: "bg-red-500" },
  { tur: "Sistem", sayi: 5, yuzde: 2, renk: "bg-gray-400" },
];

const KAMPANYA_DATA = [
  { ad: "Mayıs Referans Kampanyası", tamamlanan: 102, toplam: 243, renk: "bg-violet-500" },
  { ad: "Mayıs Ödeme Hatırlatmaları", tamamlanan: 87, toplam: 87, renk: "bg-amber-500" },
  { ad: "Taahhüt Bitiş Uyarıları", tamamlanan: 6, toplam: 18, renk: "bg-orange-500" },
  { ad: "Nisan Referans Kampanyası", tamamlanan: 198, toplam: 198, renk: "bg-emerald-500" },
  { ad: "Yeni Öğrenci Hoş Geldin", tamamlanan: 9, toplam: 14, renk: "bg-sky-500" },
];

const DURUM_PARCA = [
  { label: "Gönderildi", sayi: 234, yuzde: 75, renk: "bg-emerald-500 text-white" },
  { label: "Bekliyor", sayi: 48, yuzde: 15, renk: "bg-amber-500 text-white" },
  { label: "Hatalı", sayi: 16, yuzde: 5, renk: "bg-red-500 text-white" },
  { label: "Atlandı", sayi: 14, yuzde: 5, renk: "bg-gray-400 text-white" },
];

const DONEM_LIST = ["Son 7 Gün", "Bu Ay", "Son 30 Gün", "Son 3 Ay"];

export default function RaporlarPage() {
  const [donem, setDonem] = useState("Bu Ay");
  const maxGunluk = Math.max(...GUNLUK_DATA.map(d => d.sayi));

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-[1600px]">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900">Raporlar</h2>
          <p className="text-sm text-gray-500 mt-0.5">Gönderim, kampanya ve referans performansınızı analiz edin</p>
        </div>
        <div className="flex items-center gap-2 bg-white border border-gray-200 rounded-xl p-1">
          {DONEM_LIST.map(d => (
            <button
              key={d}
              onClick={() => setDonem(d)}
              className={`px-3 py-1.5 text-xs font-semibold rounded-lg cursor-pointer whitespace-nowrap transition-colors
                ${donem === d ? "bg-[#0B1120] text-white" : "text-gray-600 hover:bg-gray-100"}`}
            >
              {d}
            </button>
          ))}
        </div>
      </div>

      {/* Summary cards */}
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {[
          { label: "Bu Ay Gönderilen Mesaj", value: "312", sub: "+18% geçen aya göre", icon: "ri-send-plane-line", color: "bg-[#0B1120] text-white", positive: true },
          { label: "En Çok Kullanılan Şablon", value: "Ödeme Hatırlatma", sub: "189 kullanım", icon: "ri-file-text-line", color: "bg-amber-500 text-white", positive: true },
          { label: "En Aktif Kampanya", value: "Mayıs Referans", sub: "%42 ilerleme", icon: "ri-megaphone-line", color: "bg-violet-500 text-white", positive: true },
          { label: "Referans İstenen Veli", value: "243", sub: "Bu ay", icon: "ri-user-add-line", color: "bg-emerald-500 text-white", positive: true },
          { label: "Ödeme Hatırlatma", value: "87", sub: "2 hata var", icon: "ri-money-cny-circle-line", color: "bg-orange-500 text-white", positive: false },
        ].map(s => (
          <div key={s.label} className="bg-white rounded-2xl border border-gray-100 p-5">
            <div className={`w-9 h-9 rounded-xl flex items-center justify-center mb-3 ${s.color}`}>
              <i className={`${s.icon} text-sm`}></i>
            </div>
            <p className="text-xl font-bold text-gray-900 leading-tight">{s.value}</p>
            <p className="text-[11px] text-gray-500 mt-0.5 leading-tight">{s.label}</p>
            <p className={`text-[10px] mt-1.5 font-medium ${s.positive ? "text-emerald-600" : "text-red-500"}`}>{s.sub}</p>
          </div>
        ))}
      </div>

      {/* Charts row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Günlük bar chart */}
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-4">Günlük Gönderilen Mesaj Sayısı</h3>
          <div className="flex items-end gap-3 h-40">
            {GUNLUK_DATA.map(d => (
              <div key={d.gun} className="flex-1 flex flex-col items-center gap-2">
                <span className="text-[10px] text-gray-500 font-medium">{d.sayi}</span>
                <div
                  className="w-full bg-[#0B1120] rounded-t-lg transition-all"
                  style={{ height: `${(d.sayi / maxGunluk) * 100}px` }}
                />
                <span className="text-[10px] text-gray-400 whitespace-nowrap">{d.gun}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Mesaj türü dağılımı */}
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-4">Mesaj Türüne Göre Dağılım</h3>
          <div className="space-y-3">
            {TUR_DATA.map(t => (
              <div key={t.tur}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-gray-700 font-medium">{t.tur}</span>
                  <span className="text-xs text-gray-500">{t.sayi} ({t.yuzde}%)</span>
                </div>
                <div className="w-full bg-gray-100 rounded-full h-2">
                  <div className={`h-2 rounded-full ${t.renk} transition-all`} style={{ width: `${t.yuzde}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Kampanya tamamlanma oranları */}
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-4">Kampanya Tamamlanma Oranları</h3>
          <div className="space-y-4">
            {KAMPANYA_DATA.map(k => {
              const oran = Math.round((k.tamamlanan / k.toplam) * 100);
              return (
                <div key={k.ad}>
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-xs text-gray-700 font-medium truncate max-w-[200px]">{k.ad}</span>
                    <div className="flex items-center gap-2">
                      <span className="text-xs text-gray-500">{k.tamamlanan}/{k.toplam}</span>
                      <span className={`text-xs font-bold ${oran === 100 ? "text-emerald-600" : "text-gray-700"}`}>{oran}%</span>
                    </div>
                  </div>
                  <div className="w-full bg-gray-100 rounded-full h-2.5">
                    <div className={`h-2.5 rounded-full ${k.renk} transition-all`} style={{ width: `${oran}%` }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Gönderildi / Bekliyor / Hatalı */}
        <div className="bg-white rounded-2xl border border-gray-100 p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-4">Gönderim Durum Dağılımı</h3>
          {/* Stacked bar */}
          <div className="flex rounded-xl overflow-hidden h-10 mb-5">
            {DURUM_PARCA.map(p => (
              <div
                key={p.label}
                className={`${p.renk} flex items-center justify-center text-[10px] font-bold transition-all`}
                style={{ width: `${p.yuzde}%` }}
                title={`${p.label}: ${p.sayi}`}
              >
                {p.yuzde >= 10 ? `${p.yuzde}%` : ""}
              </div>
            ))}
          </div>
          <div className="grid grid-cols-2 gap-3">
            {DURUM_PARCA.map(p => (
              <div key={p.label} className="flex items-center gap-2.5">
                <div className={`w-3 h-3 rounded-full ${p.renk.replace("text-white", "").trim()}`} />
                <div>
                  <p className="text-xs font-semibold text-gray-800">{p.sayi}</p>
                  <p className="text-[11px] text-gray-400">{p.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Referans performansı */}
      <div className="bg-white rounded-2xl border border-gray-100 p-5">
        <h3 className="text-sm font-bold text-gray-900 mb-4">Referans Mesajı Performansı</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { label: "Toplam Referans Mesajı Gönderildi", value: "243", icon: "ri-send-plane-line", color: "text-violet-600 bg-violet-50" },
            { label: "Referans Veren Veli", value: "48", icon: "ri-user-shared-line", color: "text-emerald-600 bg-emerald-50" },
            { label: "Ortalama Referans / Veli", value: "1.8", icon: "ri-bar-chart-line", color: "text-sky-600 bg-sky-50" },
            { label: "Bu Ay Yeni Referans", value: "12", icon: "ri-user-add-line", color: "text-amber-600 bg-amber-50" },
          ].map(s => (
            <div key={s.label} className={`${s.color} rounded-xl p-4`}>
              <div className="w-8 h-8 flex items-center justify-center mb-2">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <p className="text-2xl font-bold text-gray-900">{s.value}</p>
              <p className="text-[11px] text-gray-600 mt-0.5 leading-tight">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}